import UsuarioEnderecoService from "@/services/UsuarioEnderecoService";

export const usuarioEndereco = {
  namespaced: true,
  state: {
    usuarioEndereco: {},
  },
  actions: {
    getUsuarioEndereco({ commit }, payload) {
      return UsuarioEnderecoService.GetUsuarioEndereco(payload).then(
        (usuarioEndereco) => {
          return Promise.resolve(usuarioEndereco);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postUsuarioEndereco({ commit }, payload) {
      return UsuarioEnderecoService.PostUsuarioEndereco(payload).then(
        (usuarioEndereco) => {
          return Promise.resolve(usuarioEndereco);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putUsuarioEndereco({ commit }, payload) {
      return UsuarioEnderecoService.PutUsuarioEndereco(payload).then(
        (usuarioEndereco) => {
          return Promise.resolve(usuarioEndereco);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteUsuarioEndereco({ commit }, payload) {
      return UsuarioEnderecoService.DeleteUsuarioEndereco(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getUsuarioEnderecoOData({ commit }, payload) {
      return UsuarioEnderecoService.GetUsuarioEnderecoOData(payload).then(
        (usuarioEndereco) => {
          return Promise.resolve(usuarioEndereco);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default usuarioEndereco;
